import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";

// Таблица маршрутов и зачем роутер без <router-view> - см. routes.ts.
// BASE_URL - база сборки: "/" обычно, "/redesign/" у экспериментальной.
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
